import { ROLE_LABEL, PERMISSIONS, BRAND } from '@app/shared/core';
import { useApp, type ThemeMode } from '../state';
import { Icon, PageHead, Seg } from '../ui';
import { TopBar } from './TopBar';

/** Вкладка «Ещё»: профиль, оформление и разделы администратора. */
export function More() {
  const { me, can, open, themeMode, setThemeMode } = useApp();
  const e = me.employee!;
  const admin = [
    can('staff.manage') && { key: 'staff', icon: 'users', title: 'Сотрудники', sub: 'Список, должности, участки, попытки входа', count: me.loginAttempts, go: () => open({ name: 'staff' }) },
    can('panel.manage') && { key: 'eq', icon: 'panels', title: 'Участки и панели', sub: 'Цеха, линии, адреса панелей, проверка связи', count: 0, go: () => open({ name: 'equipment' }) },
    { key: 'products', icon: 'factory', title: 'Номенклатура', sub: can('equipment.manage') ? 'Подшипники, места хранения, переналадка; загрузка из Excel' : 'Подшипники, характеристики, места хранения', count: 0, go: () => open({ name: 'products' }) },
    can('equipment.manage') && { key: 'imports', icon: 'upload', title: 'Загрузка таблиц', sub: 'Номенклатура, остатки, план, факт — из Excel/1С', count: 0, go: () => open({ name: 'imports' }) },
    can('equipment.manage') && { key: 'actions', icon: 'copy', title: 'Типовые действия', sub: 'Одинаковые пункты для разных машин и номенклатур', count: 0, go: () => open({ name: 'actions' }) },
    can('panel.log') && { key: 'log', icon: 'log', title: 'Журнал подключений', sub: 'Кто сейчас на панелях, что нажимал', count: 0, go: () => open({ name: 'sessions' }) },
  ].filter(Boolean) as { key: string; icon: string; title: string; sub: string; count: number; go: () => void }[];

  return (
    <div className="stack">
      <TopBar />
      <PageHead title="Ещё" />

      <section className="card stack" style={{ gap: 8 }}>
        <div className="h2">{e.fullName}</div>
        <div className="row wrap" style={{ gap: 8 }}>
          {e.position && <span className="badge outline">{e.position}</span>}
          {(e.role === 'admin' || !e.position) && <span className="badge solid">{ROLE_LABEL[e.role]}</span>}
        </div>
        <details>
          <summary className="small muted" style={{ cursor: 'pointer' }}>
            Что мне доступно
          </summary>
          <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
            {me.permissions.map((p) => (
              <li key={p} className="small">
                {PERMISSIONS[p]}
              </li>
            ))}
          </ul>
        </details>
      </section>

      {admin.length > 0 && (
        <>
          <h2 className="section-title">Разделы</h2>
          <div className="list">
            {admin.map((a) => (
              <button key={a.key} type="button" className="item" onClick={a.go}>
                <span className="mark">
                  <Icon name={a.icon} />
                </span>
                <span className="grow">
                  <span className="title" style={{ display: 'block' }}>
                    {a.title}
                  </span>
                  <span className="sub">{a.sub}</span>
                </span>
                {a.count > 0 && <span className="count">{a.count}</span>}
                <span className="chev">
                  <Icon name="right" size={18} />
                </span>
              </button>
            ))}
          </div>
        </>
      )}

      <h2 className="section-title">Оформление</h2>
      <Seg<ThemeMode>
        label="Тема"
        value={themeMode}
        onChange={setThemeMode}
        options={[
          { value: 'auto', label: 'Авто' },
          { value: 'light', label: 'Светлая' },
          { value: 'dark', label: 'Тёмная' },
        ]}
      />

      <p className="small muted" style={{ textAlign: 'center', marginTop: 16 }}>
        {BRAND.name} · этап 1
      </p>
    </div>
  );
}
